import { AnalyticsCard } from '@/components/analytics/AnalyticsCard.tsx'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { useQueryAnalyticsIterations } from '@/requests/queries/useQueryAnalytics.tsx'

export const RejectionRate = () => {
  const { apiKey } = useUserContext()
  const { iterations } = useQueryAnalyticsIterations(apiKey)

  const currentIteration = iterations?.[iterations.length - 1]
  if (!currentIteration) return

  return (
    <AnalyticsCard
      title="Rejection Rate"
      subtitle="Percentage of rejections vs. acceptances and rejections"
      contents={
        <div className="font-EN-KR-heading1-bold text-alarm-red-900">{currentIteration.analytics.rejectionRate}%</div>
      }
    />
  )
}
